import React from "react";
import { FEATURES_CONFIG } from "../../../featuresConfig";
import HoldAndWinIntroDialog from "../HoldAndWinIntroDialog/HoldAndWinIntroDialog";
import HoldAndWinReloadDialog from "../HoldAndWinReloadDialog/HoldAndWinReloadDialog";
import HoldAndWinOutroDialog from "../HoldAndWinOutroDialog/HoldAndWinOutroDialog";
import MaxWinDialog from "../MaxWinDialog/MaxWinDialog";
import FreeSpinIntroDialog from "../FreeSpin/FreeSpinIntroDialog/FreeSpinIntroDialog";
import FreeSpinOutroDialog from "../FreeSpin/FreeSpinOutroDialog/FreeSpinOutroDialog";
import FreeSpinRetriggerDialog from "../FreeSpin/FreeSpinRetriggerDialog/FreeSpinRetriggerDialog";
import RoyalCollectIntroDialog from "../RoyalCollect/RoyalCollectIntroDialog/RoyalCollectIntroDialog";
import RoyalCollectOutroDialog from "../RoyalCollect/RoyalCollectOutroDialog/RoyalCollectOutroDialog";
import PotCollectionIntroDialog from "../PotCollectionIntroDialog/PotCollectionIntroDialog";
import PotCollectionOutroDialog from "../PotCollectionOutroDialog/PotCollectionOutroDialog";
import PotCollectionGrandJackpotDialog from "../PotCollectionGrandJackpotDialog/PotCollectionGrandJackpotDialog";
import PotCollectionMaxWinDialog from "../PotCollectionMaxWinDialog/PotCollectionMaxWinDialog";
import PotCollectionReloadDialog from "../PotCollectionReloadDialog/PotCollectionReloadDialog";

const Dialogs = () => {
  return (
    <>
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <HoldAndWinIntroDialog />}
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <HoldAndWinReloadDialog />}
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <HoldAndWinOutroDialog />}
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <MaxWinDialog />}
      {FEATURES_CONFIG.FREE_SPINS.ENABLED && <FreeSpinIntroDialog />}
      {FEATURES_CONFIG.FREE_SPINS.ENABLED && <FreeSpinOutroDialog />}
      {FEATURES_CONFIG.FREE_SPINS.ENABLED && <FreeSpinRetriggerDialog />}
      {FEATURES_CONFIG.ROYAL_COLLECT.ENABLED && <RoyalCollectIntroDialog />}
      {FEATURES_CONFIG.ROYAL_COLLECT.ENABLED && <RoyalCollectOutroDialog />}
      {FEATURES_CONFIG.POT_COLLECTION.ENABLED && <PotCollectionIntroDialog />}
      {FEATURES_CONFIG.POT_COLLECTION.ENABLED && <PotCollectionOutroDialog />}
      {FEATURES_CONFIG.POT_COLLECTION.ENABLED && <PotCollectionGrandJackpotDialog />}
      {FEATURES_CONFIG.POT_COLLECTION.ENABLED && <PotCollectionMaxWinDialog />}
      {FEATURES_CONFIG.POT_COLLECTION.ENABLED && <PotCollectionReloadDialog />}
    </>
  );
};

export default Dialogs;

